import { render, staticRenderFns } from "./CheckCertificateDialog.vue?vue&type=template&id=48d928ec&scoped=true"
import script from "./CheckCertificateDialog.vue?vue&type=script&lang=js"
export * from "./CheckCertificateDialog.vue?vue&type=script&lang=js"
import style0 from "./CheckCertificateDialog.vue?vue&type=style&index=0&id=48d928ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d928ec",
  null
  
)

export default component.exports